import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiArrowRight, FiLock } from 'react-icons/fi';

export default function ContactStep({ step, currentData, onComplete }) {
  const [formData, setFormData] = useState({
    firstName: currentData?.firstName || '',
    email: currentData?.email || '',
    phone: currentData?.phone || ''
  });

  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    if (!formData.firstName.trim()) newErrors.firstName = "First name is required";
    if (!formData.email.trim() || !/^\S+@\S+\.\S+$/.test(formData.email)) {
      newErrors.email = "Valid email is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      onComplete(step.id, formData);
    }
  };

  return (
    <div className="w-full max-w-xl mx-auto flex flex-col justify-center min-h-[60vh]">
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center mb-10"
      >
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-amber-500 text-white mb-6 shadow-lg shadow-amber-500/20">
          <SafeIcon icon={FiLock} className="text-2xl" />
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-[#1A1A1A] mb-4 leading-tight tracking-tight">
          {step.title}
        </h2>
        <p className="text-zinc-500 text-lg leading-relaxed max-w-md mx-auto">
          {step.subtext}
        </p>
      </motion.div>

      <motion.form 
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
        onSubmit={handleSubmit} 
        className="space-y-4"
      >
        <div className="group">
          <input
            type="text"
            placeholder="First Name *"
            value={formData.firstName}
            onChange={(e) => setFormData({...formData, firstName: e.target.value})}
            className={`w-full p-5 rounded-2xl bg-white border outline-none text-[#1A1A1A] transition-all duration-300
              ${errors.firstName 
                ? 'border-red-500 focus:ring-2 focus:ring-red-100' 
                : 'border-zinc-200 focus:border-amber-500 focus:ring-4 focus:ring-amber-500/5'}
            `}
          />
          {errors.firstName && <span className="text-red-500 text-sm mt-2 ml-1 block font-medium">{errors.firstName}</span>}
        </div>

        <div>
          <input
            type="email"
            placeholder="Email Address *"
            value={formData.email}
            onChange={(e) => setFormData({...formData, email: e.target.value})}
            className={`w-full p-5 rounded-2xl bg-white border outline-none text-[#1A1A1A] transition-all duration-300
              ${errors.email 
                ? 'border-red-500 focus:ring-2 focus:ring-red-100' 
                : 'border-zinc-200 focus:border-amber-500 focus:ring-4 focus:ring-amber-500/5'}
            `}
          />
          {errors.email && <span className="text-red-500 text-sm mt-2 ml-1 block font-medium">{errors.email}</span>}
        </div>

        <div>
          <input
            type="tel"
            placeholder="Phone Number (Optional)"
            value={formData.phone}
            onChange={(e) => setFormData({...formData, phone: e.target.value})}
            className="w-full p-5 rounded-2xl bg-white border border-zinc-200 focus:border-amber-500 focus:ring-4 focus:ring-amber-500/5 outline-none text-[#1A1A1A] transition-all duration-300"
          />
        </div>

        <button
          type="submit"
          className="w-full mt-6 flex items-center justify-center py-5 px-6 rounded-2xl bg-amber-500 text-white font-bold text-lg hover:bg-amber-600 transition-all duration-300 shadow-xl shadow-amber-500/20 active:scale-[0.98]"
        >
          Continue
          <SafeIcon icon={FiArrowRight} className="ml-2 text-xl" />
        </button>
      </motion.form>
    </div>
  );
}